module.exports = __webpack_public_path__ + "img/ab3e96e9d3b0de284deef832a82c734b.png";